import {Component, OnInit, OnDestroy} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CustomInputEditor} from '../custom-inputEditor';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-sla',
  templateUrl: './sla.component.html',
  styleUrls: ['./sla.component.css']
})
export class SlaComponent implements OnInit, OnDestroy {

  vendorSelected: number;
  ticketSelected: number;
  groupSelected: number;
  prioritySelected: number;
  show: boolean;
  dataset: any[];
  totalData: number;
  respObject: any;
  vendors = [];
  tickets = [];
  groups = [];
  priorities = [];
  groupName: string;
  vendorName: string;
  ticketName: string;
  resoTime: string;
  respTime: string;
  name: string;
  desc: string;

  displayData: any;

  add = false;
  del = false;
  edit = false;
  view = false;

  isError = false;
  errorMessage: string;

  private notifier: NotifierService;
  private clientId: number;
  private priorityName: any;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private baseFlag: any;
  offset: number;
  dataLoaded:boolean;


  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
            item.user_id = this.messageService.getUserId();
            this._rest.updateSLADetails(item).subscribe((res) => {
              this.respObject = res;
              if (this.respObject.success) {
                this.notifier.notify('success', 'Updated successfully');
              } else {
                this.notifier.notify('error', this.respObject.errorMessage);
              }
            }, (err) => {
              this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteSLADetails({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
    // this.messageService.getUserAuth().subscribe(details => {
    //   console.log(JSON.stringify(details));
    //   if (details.length > 0) {
    //     this.add = details[0].addFlag;
    //     this.del = details[0].deleteFlag;
    //     this.view = details[0].viewFlag;
    //     this.edit = details[0].editFlag;
    //   } else {
    //     this.add = true;
    //     this.del = true;
    //     this.view = true;
    //     this.edit = true;
    //   }
    // });
  }


  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain SLA',
      openModalButton: 'Add SLA',
      breadcrumb: 'sla',
      folderName: 'All SLA',
      tabName: 'SLA'
    };
    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, maxWidth: 40, filterable: true},
      {
        id: 'name', name: 'Name', field: 'name', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'Description', name: 'Description', field: 'des', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'vendor', name: 'Vendor  ', field: 'vendor', sortable: true, filterable: true
      },
      {
        id: 'group', name: 'Support Group', field: 'groupname', sortable: true, filterable: true
      },
      {
        id: 'ticket', name: 'Ticket Type ', field: 'ticket', sortable: true, filterable: true
      },
      {
        id: 'priority', name: 'Priority', field: 'priority', sortable: true, filterable: true
      },

      {
        id: 'resTime', name: 'Resolution Time', field: 'resolutionTime', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'respTime', name: 'Response Time', field: 'responseTime', sortable: true, filterable: true, cssClass: 'highlight',editor: {
          model: CustomInputEditor,
        }
      }
    ];
    // this.messageService.setGridWidth(1000);
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
  }

  onPageLoad() {
        this._rest.getVendorMst(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            this.respObject.details.unshift({id: 0, name: 'Select Vendor'});
            this.vendors = this.respObject.details;
            this.vendorSelected = 0;
          } else {
            this.isError = true;
            this.errorMessage = this.respObject.errorMessage;
          }
        }, (err) => {
          this.isError = true;
          this.errorMessage = this.messageService.SERVER_ERROR;
        });
        // this._rest.getBusinessPriority(this.clientId).subscribe((res1) => {
        //   this.respObject = res1;
        //   if (this.respObject.success) {
        //     this.isError = false;
        //     this.respObject.details.unshift({id: 0, name: 'Select Priority'});
        //     this.priorities = this.respObject.details;
        //     this.prioritySelected = 0;
        //   } else {
        //     this.isError = true;
        //     this.errorMessage = this.respObject.errorMessage;
        //   }
        // }, (err) => {
        //   this.isError = true;
        //   this.errorMessage = this.messageService.SERVER_ERROR;
        // });
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
            this.tickets = this.respObject.details;
            this.ticketSelected = 0;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  onVendorChange(selectedIndex) {
    this.vendorName = this.vendors[selectedIndex].name;
    this._rest.getSupportGroupByVendor(this.clientId, this.vendorSelected).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Support Group'});
        this.groups = this.respObject.details;
        this.groupSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.vendorSelected = 0;
      this.ticketSelected = 0;
      this.prioritySelected = 0;
      this.ticketSelected = 0;
      this.desc = '';
      this.name = '';
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {
      });
    }
  }

  timeFormat(date) {
    // console.log(date);
    if (date !== undefined) {
      const d = new Date(date);
      const hour = d.getHours();
      const min = d.getMinutes();
      let nHour, nMin;
      if (hour < 10) {
        nHour = '0' + hour;
      } else {
        nHour = hour;
      }
      if (min < 10) {
        nMin = '0' + min;
      } else {
        nMin = min;
      }
      return nHour + ':' + nMin;
    } else {
      return '';
    }
  }

  save() {
    const data = {
      enable_escalation: 1,
      clientId: this.clientId,
      VENDORID: this.vendorSelected,
      supportGroupLevelId: this.groupSelected,
      name: this.name,
      des: this.desc,
      busi_priority_id: this.prioritySelected,
      TICKETTYPEID: this.ticketSelected,
      responseTime: this.resoTime,
      resolutionTime: this.respTime,
      createdBy: this.messageService.getUserId()
    };
    if (!this.messageService.isBlankField(data)) {

      this._rest.insertSLADetails(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          const id = this.respObject.id;
          this.messageService.setRow({
            id: id,
            ticket: this.ticketName,
            vendor: this.vendorName,
            groupname: this.groupName,
            name: this.name,
            priority: this.priorityName,
            des: this.desc,
            responseTime: this.resoTime,
            resolutionTime: this.respTime,
          });
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          this.vendorSelected = 0;
          this.ticketSelected = 0;
          this.prioritySelected = 0;
          this.ticketSelected = 0;
          this.desc = '';
          this.name = '';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }


  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getSLADetails(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  onTicketChange(selectedIndex: any) {
    this.ticketName = this.tickets[selectedIndex].name;
    this._rest.getBusinessPriorityTicketTypeWise(this.clientId,this.ticketSelected).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Priority'});
        this.priorities = this.respObject.details;
        this.prioritySelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onGroupChange(selectedIndex: any) {
    this.groupName = this.groups[selectedIndex].name;
  }

  onPriorityChange(selectedIndex: any) {
    this.priorityName = this.priorities[selectedIndex].name;
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }
}
